import { Brand, type BrandPurchaser } from "@src/domain/entities/brand";

export function isActiveBrandPurchaser(purchaser: BrandPurchaser): boolean {
  return Boolean(
    purchaser.purchaserIsActive &&
      purchaser.brandPurchaser.isActive &&
      purchaser.brandPurchaser.id != null,
  );
}

export function countActiveBrandPurchasers(
  purchasers: BrandPurchaser[] | null | undefined,
): number {
  return (purchasers ?? []).filter(isActiveBrandPurchaser).length;
}

export function applyBrandPurchaserStatusToBrand(
  brand: Brand,
  updatedPurchaser: BrandPurchaser,
): Brand {
  const purchasers = brand.brandPurchasers ?? [];
  const index = purchasers.findIndex(
    (p) => p.purchaserId === updatedPurchaser.purchaserId,
  );
  const nextPurchasers =
    index >= 0
      ? purchasers.map((p, i) => (i === index ? updatedPurchaser : p))
      : [...purchasers, updatedPurchaser];

  return Brand.withProps(brand, {
    brandPurchasers: nextPurchasers,
    brandPurchasersCount: countActiveBrandPurchasers(nextPurchasers),
  });
}
